export class Controller {

    /** @ngInject */
    constructor(LicenseManagementService, LicenseTierDetails, Alert, $stateParams) {
        this.LicenseManagementService = LicenseManagementService;
        this.LicenseTierDetails = LicenseTierDetails;
        this.Alert = Alert;
        this.$stateParams = $stateParams;
    }
 
    $onInit() {
        this.numberOfUnpaidSeats = this.currentPlan.currentUserSeats - this.currentPlan.subscribedUserSeats;
    }

    $onChanges() {
    }

    viewTierDetails() {
        this.LicenseTierDetails(this.licenseTiers);
    }

    saveEmail(email) {
        this.LicenseManagementService.changeLicenseEmail(this.$stateParams.companyId, email)
            .then(()=> {
                this.Alert('success', 'global.messages.operation-successful');
                this.currentPlan.licensingActivitiesEmailAddress = email;
            })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/current-plan/subscription-info/subscription-info.controller.js